// extracted by mini-css-extract-plugin
export default {"colorOrange":"#ff6332","clientForm":"clientForm__AyFC6","headerTitle":"headerTitle__3GEyX","totalPrice":"totalPrice__uQYSA","totalTitle":"totalTitle__11bVv","price":"price__UFW1C","formElement":"formElement__ieHeg","formInputsContainer":"formInputsContainer__CqRW_","formInputsContent":"formInputsContent__1xXqI","label":"label__29vdX","slider":"slider__3uamC","round":"round__2Fp1m","ccImgContainer":"ccImgContainer__3c4DB","footerButton":"footerButton__4QE4r"};
    if(module.hot) {
      // 1745482190561
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  